/**
 * Widthが1024px以下ならモバイルViewに切り替え。
 */
export const isMobile = () => {
  const maxWidthSize = 1024
  const checkWinowSize = () => {
    return window.innerWidth < maxWidthSize
  }
  return checkWinowSize()
}
